// import { Alert, Box, Container, Grid, Typography,Stack, Button } from "@mui/material";
// import React, { useState } from "react";
import WalletForm from "../Components/TradingTools/WalletForm.component";
import WalletList from "../Components/TradingTools/WalletList.component";
// import TaskForm from "../Components/TradingTools/TaskForm.component";
// import TaskListComponent from "../Components/TradingTools/TaskList.component";
// import ConnectMainWallet from "../Components/Common/ConnectMainWallet.components";


// const TradingToolsPage = () => {

//   const [isFormOpen, setIsFormOpen] = useState(false);
//   const [editingStrategy, setEditingStrategy] = useState(null);

//   const handleOpenCreateForm = () => {
//     setEditingStrategy(null);
//     setIsFormOpen(true);
//   };

//   const handleOpenEditForm = (strategy) => {
//     setEditingStrategy(strategy);
//     setIsFormOpen(true);
//   };

//   const handleSave = () => {
//     console.log("Strategy saved successfully!");
//     setIsFormOpen(false);
//   };

//   const handleCancel = () => {
//     setIsFormOpen(false);
//   };

//   const mockStrategy = {
//     _id: 'strat_12345', name: 'Conservative Growth', isActive: true,
//     tradeThresholdBTC: 0.005, quickBuyAmountSATS: 2000000,
//   };


//   return (
//     <Container maxWidth="xl" sx={{ padding: "2rem"}}>
//       <Grid container spacing={2} sx={{ padding: "20px" }}>
//         <Grid item xs={12} md={12}>
//           <Alert severity="info" sx={{ width: "100%", marginBottom: "20px" }}>
//             <Typography variant="h5" gutterBottom >
//               Trading Tools
//             </Typography>
//             <Typography variant="body1" >
//               The tool is being updated on the backend and is currently offline. Please check back later for more
//               features and updates.
//             </Typography>
//           </Alert>
//         </Grid>

//         <Grid item xs={12} md={12}>
//           <ConnectMainWallet />
//         </Grid>

//         <Grid item xs={12} md={3}
//           sx={{
//             // background:"red"
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//           }}
//         >
//           {/* <Typography variant="h4" gutterBottom>
//           wallets
//         </Typography> */}
//           <WalletForm />
//           <WalletList />
//         </Grid>
//         <Grid item xs={12} md={9} sx={{
//           // background: "green"
//         }}>
//           <Box>
//             <Stack direction="row" spacing={2} justifyContent={{ xs: "center", md: "flex-end"} }>
//               <Button variant="contained" color="secondary" onClick={handleOpenCreateForm}>Create New Strategy</Button>
//               {/* <Button variant="outlined" onClick={() => handleOpenEditForm(mockStrategy)}>Edit Existing Strategy</Button> */}
//             </Stack>

//           </Box>
//           <TaskListComponent />

//         </Grid>
//         {/* <Grid item xs={12} md={3} sx={{
//           // background: "blue"
//         }}>

//           <TaskForm />
//         </Grid> */}

//       </Grid>
//     </Container>

//   );
// };
// export default TradingToolsPage;


import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  CssBaseline,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Switch,
  FormControlLabel,
  CircularProgress,
  Alert,
  Divider,
  IconButton,
  Stack,
  useTheme,
  Chip,
  Paper, // Added Paper for grouping
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// --- Mock Service & Auth ---
const strategyService = {
  createStrategy: async (data, token) => {
    console.log("Creating strategy:", data, "with token:", token);
    await new Promise(resolve => setTimeout(resolve, 1500));
    if (data.name.toLowerCase().includes('fail')) {
      throw new Error("Invalid strategy name provided.");
    }
    return { ...data, _id: `strat_${ Date.now() }` };
  },
  updateStrategy: async (id, data, token) => {
    console.log("Updating strategy:", id, data, "with token:", token);
    await new Promise(resolve => setTimeout(resolve, 1500));
    if (data.name.toLowerCase().includes('fail')) {
      throw new Error("Invalid strategy name provided during update.");
    }
    return { ...data, _id: id };
  }
};

const useAuth = () => ({
  token: 'mock-jwt-token'
});


// --- FORM COMPONENT ---
function StrategyForm({ strategy, onSave, onCancel, open = true }) {
  const { t } = useTranslation();
  const currentTheme = useTheme(); // Use theme from context
  const { token } = useAuth();

  const [formData, setFormData] = useState({
    name: '', isActive: false, tradeThresholdBTC: 0.0019, quickBuyAmountSATS: 5000000,
    maxUserTransfersWindow: 2, maxTokenAgeHours: 12, sellSignalThresholdBTC: 0.0019,
    stopLossPercent: 0.09, trailActivationPercent: 0.15, trailPercent: 0.08,
    maxTradeDurationHours: 1, sellOnNoBuyMinutes: 2,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (strategy) {
      setFormData({
        name: strategy.name || '', isActive: strategy.isActive || false,
        tradeThresholdBTC: strategy.tradeThresholdBTC || 0.0019,
        quickBuyAmountSATS: strategy.quickBuyAmountSATS || 5000000,
        maxUserTransfersWindow: strategy.maxUserTransfersWindow || 2,
        maxTokenAgeHours: strategy.maxTokenAgeHours || 12,
        sellSignalThresholdBTC: strategy.sellSignalThresholdBTC || 0.0019,
        stopLossPercent: strategy.stopLossPercent || 0.09,
        trailActivationPercent: strategy.trailActivationPercent || 0.15,
        trailPercent: strategy.trailPercent || 0.08,
        maxTradeDurationHours: strategy.maxTradeDurationHours || 1,
        sellOnNoBuyMinutes: strategy.sellOnNoBuyMinutes || 2,
      });
    }
  }, [strategy]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === 'checkbox' ? checked : type === 'number' ? parseFloat(value) : value;
    setFormData(prev => ({ ...prev, [name]: val }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      if (strategy?._id) {
        await strategyService.updateStrategy(strategy._id, formData, token);
      } else {
        await strategyService.createStrategy(formData, token);
      }
      onSave();
    } catch (err) {
      setError(err.message || 'An unknown error occurred.');
    } finally {
      setIsLoading(false);
    }
  };

  const renderField = (label, name, type = 'number', step = '0.01', props = {}) => (
    <TextField fullWidth type={type} label={label} name={name} id={name} value={formData[name]}
      onChange={handleChange} variant="outlined" InputLabelProps={{ shrink: true }}
      inputProps={{ step }} {...props}
    />
  );

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="md" fullWidth component="form" onSubmit={handleSubmit}>
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5" component="div">
          {strategy ? t('trading.editStrategy') : t('trading.createNewStrategy')}
        </Typography>
        <IconButton aria-label="close" onClick={onCancel} sx={{ color: 'text.secondary' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            {renderField(t('trading.strategyName'), 'name', 'text', undefined, { placeholder: t('trading.strategyNamePlaceholder') })}
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <FormControlLabel
              control={<Switch checked={formData.isActive} onChange={handleChange} name="isActive" color="secondary" />}
              label={formData.isActive ? t('trading.statusActive') : t('trading.statusInactive')}
            />
          </Grid>

          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 2, borderColor: 'rgba(255,255,255,0.2)', borderRadius: 2, backgroundColor: 'rgba(0,0,0,0.2)' }}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>{t('trading.entryStrategy')}</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>{renderField(t('trading.tradeThresholdBTC'), 'tradeThresholdBTC', 'number', '0.0001')}</Grid>
                <Grid item xs={12} sm={6} md={3}>{renderField(t('trading.quickBuyAmountSATS'), 'quickBuyAmountSATS', 'number', '1000')}</Grid>
                <Grid item xs={12} sm={6} md={3}>{renderField(t('trading.maxUserTransfers'), 'maxUserTransfersWindow', 'number', '1')}</Grid>
                <Grid item xs={12} sm={6} md={3}>{renderField(t('trading.maxTokenAgeHours'), 'maxTokenAgeHours', 'number', '1')}</Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 2, borderColor: 'rgba(255,255,255,0.2)', borderRadius: 2, backgroundColor: 'rgba(0,0,0,0.2)' }}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>{t('trading.exitStrategy')}</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>{renderField(t('trading.sellSignalBTC'), 'sellSignalThresholdBTC', 'number', '0.0001')}</Grid>
                <Grid item xs={12} sm={6} md={3}>{renderField(t('trading.stopLossPercent'), 'stopLossPercent', 'number', '0.01')}</Grid>
                <Grid item xs={12} sm={6} md={3}>{renderField(t('trading.trailActivationPercent'), 'trailActivationPercent', 'number', '0.01')}</Grid>
                <Grid item xs={12} sm={6} md={3}>{renderField(t('trading.trailPercent'), 'trailPercent', 'number', '0.01')}</Grid>
                <Grid item xs={12} sm={6} md={3}>{renderField(t('trading.maxTradeDurationHours'), 'maxTradeDurationHours', 'number', '0.5')}</Grid>
                <Grid item xs={12} sm={6} md={3}>{renderField(t('trading.sellOnInactivityMinutes'), 'sellOnNoBuyMinutes', 'number', '1')}</Grid>
              </Grid>
            </Paper>
          </Grid>

        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onCancel} color="inherit">{t('common.cancel')}</Button>
        <Button type="submit" variant="contained" color="secondary" disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isLoading ? t('common.saving') : (strategy ? t('common.saveChanges') : t('trading.createStrategy'))}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// --- Example Parent Component Usage ---
export default function App() {
  const { t } = useTranslation();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingStrategy, setEditingStrategy] = useState(null);
  const [strategies, setStrategies] = useState([
    { _id: 'strat_12345', name: 'Conservative Growth', isActive: true, tradeThresholdBTC: 0.005, quickBuyAmountSATS: 2000000 },
    { _id: 'strat_67890', name: 'Aggressive Scalper', isActive: false, tradeThresholdBTC: 0.001, quickBuyAmountSATS: 10000000 },
    { _id: 'strat_abcde', name: 'Momentum Hunter', isActive: true, tradeThresholdBTC: 0.002, quickBuyAmountSATS: 5000000 },
  ]);

  const handleOpenCreateForm = () => {
    setEditingStrategy(null);
    setIsFormOpen(true);
  };

  const handleOpenEditForm = (strategy) => {
    setEditingStrategy(strategy);
    setIsFormOpen(true);
  };

  const handleSave = () => {
    console.log("Strategy saved successfully!");
    setIsFormOpen(false);
    // Here you would typically refetch your list of strategies
  };

  const handleCancel = () => {
    setIsFormOpen(false);
  };

  const handleDelete = (id) => {
    // In a real app, you would call a service here.
    console.log("Deleting strategy:", id);
    setStrategies(prev => prev.filter(s => s._id !== id));
  };


  return (
    <Container sx={{ p: 4 }}>
      <Stack direction="row" spacing={2} sx={{ mb: 4 }} justifyContent={{ xs: 'center', md: 'space-between' }}>
        <Typography variant="h4" gutterBottom>{t('trading.strategyManagement')}</Typography>

        <Button variant="contained" color="secondary" onClick={handleOpenCreateForm} disabled>{t('trading.createNewStrategy')}</Button>
      </Stack>

      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <WalletForm />
          <WalletList />
        </Grid>
        <Grid item xs={12} md={9}>
          <Paper sx={{ p: 2, position: 'relative' }}>
            {/* Overlay for under construction */}
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10,
                borderRadius: 1
              }}
            >
              <Typography variant="h5" sx={{ color: 'white', mb: 2, fontWeight: 'bold' }}>
                {t('trading.strategyCreationManagement')}
              </Typography>
              <Typography variant="body1" sx={{ color: 'white', textAlign: 'center' }}>
                {t('trading.underConstruction')}
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', mt: 1 }}>
                {t('trading.willBeAvailableSoon')}
              </Typography>
            </Box>

            <Typography variant="h6" sx={{ mb: 2 }}>{t('trading.yourStrategies')}</Typography>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t('common.name')}</TableCell>
                    <TableCell>{t('common.status')}</TableCell>
                    <TableCell align="right">{t('common.actions')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {strategies.map((strat) => (
                    <TableRow key={strat._id}>
                      <TableCell component="th" scope="row">
                        {strat.name}
                      </TableCell>
                      <TableCell>
                        <Chip label={strat.isActive ? t('common.active') : t('common.inactive')} color={strat.isActive ? 'success' : 'default'} size="small" variant="outlined" />
                      </TableCell>
                      <TableCell align="right">
                        <IconButton size="small" onClick={() => handleOpenEditForm(strat)}><EditIcon fontSize="small" /></IconButton>
                        <IconButton size="small" onClick={() => handleDelete(strat._id)}><DeleteIcon fontSize="small" /></IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

        </Grid>
      </Grid>
      {isFormOpen && (
        <StrategyForm strategy={editingStrategy} onSave={handleSave} onCancel={handleCancel} open={false} />
      )}
    </Container>
  );
}
